import { render, staticRenderFns } from "./TerritorySR.vue?vue&type=template&id=1736a01b"
import script from "./TerritorySR.vue?vue&type=script&lang=js"
export * from "./TerritorySR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports